import { reactive } from 'vue';

export const useNotificationsDetail = () => {
    const state = reactive({
        id: '',
        titulo: '',
        user: {},
        body: '',
        read: Boolean,
        status: 1,
    });

    const setState = (c) => {
        state.id = c.id;
        state.titulo = c.titulo;
        state.user = c.user;
        state.body = c.body;
        state.read = c.read;
        state.status = c.status;
    };

    return {
        state,
        setState,
    };
};

export default {};
